import React from "react";
import ConfirmationModal from "components/shared/confirmation-modal";
import StatusModal from "components/shared/status-modal";
import { DriverDraftRow } from "../types";

interface ListModalsProps {
  t: any;
  isDeleteOpen: boolean;
  setIsDeleteOpen: (open: boolean) => void;
  driverToDelete: DriverDraftRow | null;
  setDriverToDelete: (row: DriverDraftRow | null) => void;
  onConfirmDelete: () => void;
  isDeleting: boolean;
  showBulkConfirmModal?: boolean;
  setShowBulkConfirmModal?: (show: boolean) => void;
  onConfirmBulkDelete?: () => void;
  selectedKeys?: (string | number)[];
  statusModal: {
    show: boolean;
    type: "success" | "error" | "warning";
    title: string;
    message: React.ReactNode;
  };
  setStatusModal: (val: any) => void;
}

const ListModals: React.FC<ListModalsProps> = ({
  t,
  isDeleteOpen,
  setIsDeleteOpen,
  driverToDelete,
  setDriverToDelete,
  onConfirmDelete,
  isDeleting,
  showBulkConfirmModal,
  setShowBulkConfirmModal,
  onConfirmBulkDelete,
  selectedKeys,
  statusModal,
  setStatusModal,
}) => {
  return (
    <>
      <ConfirmationModal
        open={isDeleteOpen}
        title={t("modal-discard-draft-title") || "Discard Draft"}
        message={t("modal-discard-draft-message", { name: driverToDelete?.driverName || "this driver" })}
        confirmLabel={t("btn-discard") || "Discard"}
        cancelLabel={t("btn-cancel")}
        onConfirm={onConfirmDelete}
        onCancel={() => {
          setIsDeleteOpen(false);
          setDriverToDelete(null);
        }}
        loading={isDeleting}
        icon="danger"
      />

      <ConfirmationModal
        open={!!showBulkConfirmModal}
        title={t("modal-bulk-discard-title") || "Discard Selected Drafts"}
        message={t("modal-bulk-discard-message", { count: selectedKeys?.length || 0 })}
        confirmLabel={t("btn-discard-all") || "Discard All"}
        cancelLabel={t("btn-cancel")}
        onConfirm={onConfirmBulkDelete || (() => {})}
        onCancel={() => setShowBulkConfirmModal?.(false)}
        loading={isDeleting}
        icon="danger"
      />

      <StatusModal
        open={statusModal.show}
        type={statusModal.type}
        title={statusModal.title}
        message={statusModal.message}
        closeLabel={t("btn-close") || "Close"}
        onClose={() => setStatusModal({ ...statusModal, show: false })}
      />
    </>
  );
};

export default ListModals;
